import PropTypes from 'prop-types';
import Link from 'next/link';
// Components
import RichTextContent from '../../atoms/RichTextContent/RichTextContent';
import Button from '../../atoms/Button/Button';
// Styles
import styles from './CardEvent.module.css';

function CardEvent({
  title,
  subtitle,
  startDate,
  endDate,
  hoursInfo,
  description,
  ctaLabel,
  ctaUrl,
  media,
}) {
  // Utils
  const getDateComponent = () => {
    const sDate = new Date(startDate);
    const eDate = new Date(endDate);
    const isSameDay = sDate.toDateString() === eDate.toDateString();
    const stringDateDay = isSameDay ? `${sDate.getDate()}` : `${sDate.getDate()} au ${eDate.getDate()}`;

    return (
      <time className={styles.date} dateTime={`${startDate}/${endDate}`}>
        <span className={styles.dateDay}>{stringDateDay}</span>
        <span className={styles.dateMonth}>{`${eDate.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' })}`}</span>
      </time>
    );
  };

  return (
    <article className={styles.card}>
      <div className={styles.header} style={{ backgroundImage: `url(${media?.url})` }}>
        {getDateComponent()}
      </div>

      <div className={styles.content}>
        <div className={styles.titleWrapper}>
          <h3 className={styles.title}>{title}</h3>
          {subtitle && (
            <p className={styles.subtitle}>
              {subtitle}
            </p>
          )}
        </div>

        <time className={styles.time}>{hoursInfo}</time>

        <div className={styles.description}>
          <RichTextContent content={description} />
        </div>

        {ctaUrl && (
          <div className={styles.footer}>
            <Link href={`${ctaUrl}`} name={ctaLabel} className={styles.cta}>
              <Button
                color="primary"
                usageContext="light"
                className={styles.cta}
              >
                {ctaLabel}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </article>
  );
}

CardEvent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.number,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  hoursInfo: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  media: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
};

CardEvent.defaultProps = {
  subtitle: null,
  ctaLabel: null,
  ctaUrl: null,
};

export default CardEvent;
